document.addEventListener('DOMContentLoaded', () => {
  // Als je meerdere collecties/kaarten hebt, werkt dit op allemaal
  const cards = document.querySelectorAll('.card-wrapper');

  // Hover over een swatch = foto wisselen + hover-swap locken
  document.querySelectorAll('.jaro-swatch').forEach(swatch => {
    swatch.addEventListener('mouseenter', (e) => {
      const el = e.currentTarget;
      const card = el.closest('.card-wrapper');
      if (!card) return;

      // Lock hover-swap zodat Dawn de 2e foto niet inblendt
      card.classList.add('jaro-lock-image');

      const imgUrl = el.getAttribute('data-variant-img');
      if (!imgUrl) return;

      // Pak de hoofdafbeelding van de kaart (eerste img in .card__media)
      const img = card.querySelector('.card__media img');
      if (!img) return;

      // Oorspronkelijke waarden 1x bewaren
      if (!img.dataset.jaroOrigSrc) {
        img.dataset.jaroOrigSrc = img.currentSrc || img.src || '';
      }
      if (!img.dataset.jaroOrigSrcset && img.srcset) {
        img.dataset.jaroOrigSrcset = img.srcset;
      }

      // Zet swatch-foto (reset srcset om geforceerd te laden)
      img.srcset = '';
      img.src = imgUrl;
    });
  });

  // Als je de kaart verlaat: reset naar origineel en unlock
  cards.forEach(card => {
    card.addEventListener('mouseleave', () => {
      const img = card.querySelector('.card__media img');
      if (img) {
        if (img.dataset.jaroOrigSrc) {
          img.src = img.dataset.jaroOrigSrc;
        }
        if (img.dataset.jaroOrigSrcset) {
          img.srcset = img.dataset.jaroOrigSrcset;
        }
      }
      card.classList.remove('jaro-lock-image');
    });
  });
});